// /* eslint-disable react/prop-types */
// import PathMap from "../lib/PathMap";
// import Footer from "./Footer";
// import Nav from "./Nav2";

// function Layout2({ children, LeftBar, paths = [], pageName = [] }) {
//   return (
//     <div
//       className={`w-screen dark h-screen overflow-hidden grid grid-cols-18 grid-rows-20 `}
//     >
//       {/* <Nav/> */}
//       {LeftBar != undefined && LeftBar}
//       <div
//         className={` bg-cblack row-span-19 ${
//           LeftBar == undefined ? " col-span-20" : "col-span-17"
//         } `}
//       >
//       <Nav LeftBar={LeftBar} />

//         <div className={` w-full h-full ${LeftBar == undefined ? " col-span-20" : "col-span-17"} row-span-18 px-2 pb-20 border-t border-color overflow-auto overflow-x-auto shrink-0 `}>
//           <PathMap pageName={pageName} paths={paths} />
//           {children}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default Layout2;

/* eslint-disable react/prop-types */
import PathMap from "../lib/PathMap";
import Footer from "./Footer";
import Nav from "./Nav2";

function Layout2({ children, LeftBar, paths = [], pageName = {}, footer = true }) {
  const hasPageNameData = pageName && Object.keys(pageName).length > 0;
  const hasPaths = Array.isArray(paths) && paths.length > 0;
  const shouldRenderPathMap = hasPageNameData || hasPaths;
  return (
    <div className={`dark h-screen overflow-hidden flex w-full `}>
      {/* <Nav/> */}
      {LeftBar != undefined && LeftBar}
      <div className={` bg-cblack flex-1 flex flex-col min-w-0`}>
        <Nav LeftBar={LeftBar} />
        <div className={`w-full h-full overflow-auto`}>
          {shouldRenderPathMap && <PathMap pageName={pageName} paths={paths} />}
          {children}
        </div>
        {
          footer &&
          <Footer />
        }
      </div>
    </div>
  );
}

export default Layout2;
